import ExerciserResultsScore from "../../../others/courses/exercisers/ExerciserResultsScore";
import SystemResultsSummaryDivider from "../../../dividers/SystemResultsSummaryDivider";
import ExerciserResultsDetailedScores from "../../../others/courses/exercisers/ExerciserResultsDetailedScores";
import {
    ExerciserResultsScoreCardContentLayout
} from "../../../layouts/courses/exercisers/ExerciserResultsScoreCardContentLayout";

export default function ExerciserResultsScoreCard({scores, total}) {
    // Used in FlashResultsTabletSummary to display flash scores
    // in desktop mode

    // BUILD
    return (
        <div className={"hidden h-[168px] min-h-[168px] w-[384px] min-w-[384px] sm:flex sm:flex-col bg-backgroundLight5 shadow-[inset_0px_1px_2px_rgba(82,96,120,1)] rounded-[16px]"}>
            <ExerciserResultsScoreCardContentLayout>
                <ExerciserResultsScore correctAnswers={scores[0]}
                                       total={total} />
                <SystemResultsSummaryDivider />
                <ExerciserResultsDetailedScores good={scores[0]}
                                                bad={scores[1]} />
            </ExerciserResultsScoreCardContentLayout>
        </div>
    );
}